import React, { useState } from "react";
import { useKeenSlider } from "keen-slider/react";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowRight } from "lucide-react";
import "keen-slider/keen-slider.min.css";

const policiesData = [
    {
        id: 1,
        title: "Environmental Sustainability Policy",
        link: "#"
    },
    {
        id: 2,
        title: "Carbon Reduction Plan",
        link: "#"
    },
    {
        id: 3,
        title: "Supplier Code of Conduct",
        link: "#"
    },
    {
        id: 4,
        title: "Modern Slavery Statement",
        link: "#"
    }
];

const OurPolicies = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const [sliderRef, instanceRef] = useKeenSlider({
        initial: 0,
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
        loop: true,
        slides: {
            perView: 1,
            spacing: 16,
        },
        breakpoints: {
            "screen and (min-width: 640px)": {
                slides: { perView: 2, spacing: 20 },
            },
            "screen and (min-width: 1024px)": {
                slides: { perView: 3, spacing: 24 },
            },
        },
    }, [
        (slider) => {
            let timeout;
            let mouseOver = false;
            function clearNextTimeout() {
                clearTimeout(timeout);
            }
            function nextTimeout() {
                clearTimeout(timeout);
                if (mouseOver) return;
                timeout = setTimeout(() => {
                    slider.next();
                }, 3000);
            }
            slider.on("created", () => {
                slider.container.addEventListener("mouseover", () => {
                    mouseOver = true;
                    clearNextTimeout();
                });
                slider.container.addEventListener("mouseout", () => {
                    mouseOver = false;
                    nextTimeout();
                });
                nextTimeout();
            });
            slider.on("animationEnded", nextTimeout);
            slider.on("updated", nextTimeout);
        },
    ]);

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.15 },
        },
    };

    const cardVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
    };

    return (
        <section className="w-full bg-white pb-12 sm:pb-16 md:pb-20 lg:pb-24 text-left relative z-10 overflow-hidden">
            <div className="max-w-[1440px] mx-auto w-full px-5 sm:px-10 lg:px-[80px] ">

                <div className="text-center mb-10 sm:mb-14 md:mb-16 w-full">
                    <h2 className="text-[20px] md:text-[30px] font-[600] font-sora text-[#01386A] leading-tight tracking-tight">
                        Our policies
                    </h2>
                </div>

                <motion.div
                    ref={sliderRef}
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}

                >
                    <div className="keen-slider">
                        {policiesData.map((policy) => (
                            <motion.div
                                key={policy.id}
                                variants={cardVariants}
                                className="keen-slider__slide"
                            >
                                <div className="group relative w-full bg-[#F0F0F0] p-[20px] sm:p-[40px] flex flex-col justify-between items-start min-h-[260px] sm:min-h-[300px] transition-shadow duration-300 hover:shadow-md">

                                    <h3 className="text-[16px] md:text-[20px] font-[600] font-sora text-[#01386A] leading-[1.3] tracking-tight break-words max-w-[280px]">
                                        {policy.title}
                                    </h3>

                                    <a
                                        href={policy.link}
                                        className="inline-flex items-center gap-2 text-[14px] sm:text-[16px] font-[500] font-graphik text-[#01386A] pb-0.5 transition-colors duration-300 pointer-events-auto select-none outline-none mt-6 shrink-0"
                                    >
                                        <span>Download Now</span>
                                        <span className="transition-transform duration-300 group-hover:translate-x-1 text-[16px]">&gt;</span>
                                    </a>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>

                <div className="flex items-center gap-3 w-full justify-start px-1 mt-8 sm:mt-10 md:mt-12">
                    <button
                        onClick={() => instanceRef.current?.prev()}
                        className="w-10 h-10 rounded-full border border-[#ED6800] text-[#ED6800] flex items-center justify-center bg-transparent hover:bg-[#ED6800] hover:text-white transition-all duration-300 cursor-pointer outline-none select-none"
                        title="Previous slide"
                    >
                        <ArrowLeft size={18} />
                    </button>
                    <button
                        onClick={() => instanceRef.current?.next()}
                        className="w-10 h-10 rounded-full border border-[#ED6800] text-[#ED6800] flex items-center justify-center bg-transparent hover:bg-[#ED6800] hover:text-white transition-all duration-300 cursor-pointer outline-none select-none"
                        title="Next slide"
                    >
                        <ArrowRight size={18} />
                    </button>
                </div>

            </div>
        </section>
    );
};

export default OurPolicies;